let cachedContainer: HTMLElement | null = null;

function resolveContainer(): HTMLElement | null {
  if (cachedContainer && document.body.contains(cachedContainer)) {
    return cachedContainer;
  }
  cachedContainer = document.querySelector<HTMLElement>('[data-scroll-container]');
  if (!cachedContainer) {
    console.warn('[scrollContainer] Scroll container not found');
  }
  return cachedContainer;
}

export function getScrollContainer(): HTMLElement | null {
  return resolveContainer();
}

export function getScrollTop(): number {
  const container = resolveContainer();
  return container ? container.scrollTop : window.scrollY;
}

export function setScrollTop(top: number, behavior: ScrollBehavior = 'auto'): void {
  const container = resolveContainer();
  if (container) {
    container.scrollTo({ top, behavior });
  } else {
    window.scrollTo({ top, behavior });
  }
}

export function getScrollHeight(): number {
  const container = resolveContainer();
  return container ? container.scrollHeight : document.documentElement.scrollHeight;
}

export function addScrollListener(listener: (scrollTop: number) => void): () => void {
  const container = resolveContainer();
  if (container) {
    const handler = () => listener(container.scrollTop);
    container.addEventListener('scroll', handler, { passive: true });
    return () => container.removeEventListener('scroll', handler);
  }
  const handler = () => listener(window.scrollY);
  window.addEventListener('scroll', handler, { passive: true });
  return () => window.removeEventListener('scroll', handler);
}

export function scrollToElement(element: HTMLElement, behavior: ScrollBehavior = 'smooth'): void {
  const container = resolveContainer();
  if (container) {
    const top = element.offsetTop;
    container.scrollTo({ top, behavior });
  } else {
    element.scrollIntoView({ behavior, block: 'start', inline: 'nearest' });
  }
}
